<template lang="html">
  <div class="content-first">
    <!-- <div class="item" id="skinny1">
      <img id="right-quick" @click="scrollToProject('right-quick-project-container')" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/commy_a1hgjm.png" alt="">
    </div>
    <div class="item" @click="scrollToProject('fraga-project-container')" id="skinny2">
      <img id="frags" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/smiles_vog5i5.png" alt="">
    </div>
    <div class="item" @click="scrollToProject('voyager-project-container')" id="fat">
      <img id="voyager" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/turntable_gixpis.png" alt="">
    </div> -->
  </div>
</template>

<script type="text/javascript">
const scrollController = new ScrollMagic.Controller();

  export default {
    mounted() {

      document.getElementById('navvy').style.opacity = 1;
      document.getElementById('skinny1').style.opacity = 1;
      document.getElementById('skinny2').style.opacity = 1;
      document.getElementById('fat').style.opacity = 1;
    },
    methods: {
      scrollToProject(el) {
        return;
        if (el === "fraga-project-container" && window.innerWidth <= 700) {
          let selectedElement = document.getElementsByClassName("projects-container")[0];
          selectedElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'  })
        } else {
          let selectedElement = document.getElementsByClassName(el)[0];
          selectedElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'  })
        }
      }
    }
  }
</script>

<style lang="css">

.content-first {
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#skinny1 {
  width: 29.5%;
  height: 350px;
  background-color: #f7f7f7;
  opacity: 0;
  transition: opacity 1s;
}

#skinny2 {
  width: 29.5%;
  height: 350px;
  background-color: #fde100;
  opacity: 0;
  transition: opacity 1s;
}

#fat {
  width: 39.5%;
  height: 350px;
  background-color: #000;
  opacity: 0;
  transition: opacity 1s;
}

  #right-quick {
  height: 100%;
  float: right;
  display: block;
  transition: transform 1s;
}

#frags {
  height: 100%;
  display: block;
  transition: transform 1s;
}

#voyager {
  height: 112%;
  display: block;
  float: right;

}
.item {
    overflow: hidden;
    /* cursor: pointer; */
}
.item:hover>img {
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  transition: transform 1s;
}

/* MOBILE RESPONSIVE */
@media only screen and (max-width: 700px) {
  .content-first {
    display: block;
    margin-top: 50px;
  }

  #skinny1, #skinny2, #fat {
    width: 100%;
    height: 155px;
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// Hero.vue?0eabb4b1